import { atom } from 'recoil';

export const BOOKING_TEMPLATE_DEFAULT = {
  name: '',
  regions: [],
  timezone: '',
  zones: [],
  reservation: {},
  crewIds: [],
  startBookingTime: '',
  endBookingTime: '',
  crews: [],
};

// eslint-disable-next-line import/prefer-default-export
export const bookingTemplateFiltersState = atom({
  key: 'booking-template/filter/state',
  default: {
    regions: [],
    page: 1,
  },
});

export const currentBookingTemplateState = atom({
  key: 'booking-template/current/state',
  default: BOOKING_TEMPLATE_DEFAULT,
});

export const regionsState = atom({
  key: 'booking-template/regions',
  default: [],
});

export const warehousesState = atom({
  key: 'booking-template/warehouses',
  default: [],
});

export const bookingTemplatesState = atom({
  key: 'booking-templates-state',
  default: [],
});
